module.exports = __webpack_public_path__ + "img/machine_sale.a7366f0b.png";